import { inject } from '@angular/core';
import { CookieStorageEngine } from './cookie-storage-engine';
import { AuthStateModel } from './store/auth/auth-state.model';

export function tokenGetter(): string | null {
  const cookieStorage = inject(CookieStorageEngine);
  const cookie = cookieStorage.getItem('auth');
  if (!cookie) {
    return null;
  }
  const auth = JSON.parse(cookie);
  return auth?.token || null;
}
